<template>
  <section class="w-full max-w-md">
    <h6 class="text-center mb-4">
      <template v-if="!$store.state.user.firstname">
        Please sign in to start
      </template>
      <template v-else>
        Logged as {{ $store.state.user.firstname }} {{ $store.state.user.lastname }}
      </template>
    </h6>

    <div
      v-if="showLoginForm"
      class="box"
    >
      <!-- @todo should be dynamic components -->
      <form @submit.prevent="loginForm">
        <!-- Login Form -->
        <template v-if="companies.length < 2 || !showCompanies">
          <div class="field">
            <div class="control">
              <label class="label">Email</label>
              <input
                ref="email"
                name="email"
                class="input"
                type="email"
                placeholder="Your Email"
                autofocus=""
                required
                value=""
              >
            </div>

            <div class="field">
              <div class="control">
                <label class="label">Password</label>
                <div class="control has-icons-left has-icons-right">
                  <input
                    ref="password"
                    name="password"
                    class="input"
                    type="password"
                    placeholder="Your Password"
                    required
                    value=""
                  >
                  <span
                    ref="eye"
                    class="icon is-small is-right"
                    @click="showPassword"
                  >
                    <i class="fas fa-eye" />
                  </span>
                </div>
              </div>
            </div>

            <div class="flex justify-end mb-4">
              <router-link
                to="/login/forgot"
                class="underline text-xs"
              >
                Forgot password?
              </router-link>
            </div>
            <button
              type="submit"
              class="button block is-info w-full"
            >
              Login
            </button>
          </div>
        </template>

        <!-- Companies Select Form -->
        <template v-if="companies.length > 1 && showCompanies">
          <!-- SELECT COMPANY PART -->
          <div class="field">
            <div class="control">
              <label class="label">Select the company you want to log in</label>
              <div class="select is-fullwidth">
                <div class="select-container">
                  <select ref="company">
                    <option
                      selected
                      disabled
                      hidden
                      value=""
                    >
                      Choose your company...
                    </option>
                    <template v-for="(currentCompany) in companies">
                      <option
                        :key="currentCompany.uuid + Math.random()"
                        :value="currentCompany.uuid"
                      >
                        {{ currentCompany.name }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <button class="button is-block is-info is-fullwidth mt-5">
            Go to Dashboard
          </button>
        </template>
      </form>
    </div>
  </section>
</template>

<script>
import DashboardService from '../services/dashboard.service';
import UserService from '../services/user.service';
import WorkflowService from '../services/workflow.service';
import AuthService from '../services/auth.service';
import { Routes, Roles } from '../constants';

const workflowService = new WorkflowService();
const dashboardService = new DashboardService();
const userService = new UserService();
const authService = new AuthService();

export default {
  name: 'LoginComponent',
  data() {
    return {
      info: null,
      companies: [],
      rememberMe: false,
      passwordInputConfig: {
        text: {
          type: 'password',
          color: '#dbdbdb'
        },
        password: {
          type: 'text',
          color: '#000'
        }
      },
      showCompanies: false,
      redirectToProfile: false
    };
  },
  mounted() {
    const { user } = this.$store.state;
    const { organization } = this.$store.state;
    const hasOrganization = !!(organization && Object.keys(organization).length);

    if (this.$root.showCompanies) {
      this.showCompanies = true;
      this.$root.showCompanies = false;
    } else if (user) {
      if (user.role !== Roles.SUPER_ADMIN || hasOrganization) {
        this.$router.push({ name: Routes.DASHBOARD.name });
        return;
      } if (!hasOrganization) {
        this.showCompanies = true;
      }
    }
    this.$root.showHeader = false;
    // if user logged but didnt chosen a company, get them from store
    if (this.$store.state.locationsList) this.companies = this.$store.state.organizations;
    this.$root.$emit('checkToastQueue', 'resetPassword');
  },
  updated() {
    if (!this.$store.state.organizations.length) {
      this.companies = this.$store.state.organizations;
    }
  },
  methods: {
    loginForm(e) {
      e.preventDefault();
      const self = this;
      const elButton = this.$el.querySelector('button');
      elButton.classList.add('is-loading');
      // there's a company list ? it's a second form submit when user choose company from list
      if (this.companies.length && this.$store.state.accessToken) {
        // specific case : user submitted email + password but has never chosen a company in the list before expirationDate
        const isUserLogged = this.$store.state.accessToken && this.$store.state.expirationDate > (new Date()).getTime();
        if (isUserLogged) {
          const organization = this.companies.find((company) => company.uuid === this.$refs.company.value);
          if (this.$refs.company.value) {
            this.getLocations(this.$store.state.user.role, organization.uuid);
            this.$store.commit('setOrganization', { organization });
          } else {
            elButton.classList.remove('is-loading');
          }
        } else {
          this.$store.dispatch('logout', () => { self.$router.push({ name: 'login' }); });
        }
        return;
      }

      // first form submit ? we have to log the user and get info
      const data = new FormData();
      data.append('email', this.$refs.email.value.toLowerCase());
      data.append('password', this.$refs.password.value);
      data.append('client_id', this.$store.state.CLIENT_CREDENTIALS.client_id);
      data.append('client_secret', this.$store.state.CLIENT_CREDENTIALS.client_secret);

      // trying to log user with its password
      authService.login(data)
        .then((response) => {
          // @todo RECHECK!
          // eslint-disable-next-line no-shadow
          const { data } = response;
          const { status, result } = data;
          // user is logged in, we store its access_token, refresh_token and so on
          if (status === 'success') {
            if (!self.rememberMe) result.refresh_token = null;
            self.$store.commit('login', data);
            self.$store.commit('setPermissions', result.permissions);
            const { user } = result;
            const { role, firstname, lastname } = user;

            if (!firstname || !lastname) {
              self.redirectToProfile = true;
            }

            if (role === Roles.SUPER_ADMIN || role === Roles.CS_ADMIN) {
              userService.getOrganizations()
                .then((resp) => {
                  const organizationData = resp.data;
                  const { status: organizationStatus, result: organizationResult } = organizationData;

                  if (organizationStatus === 'success') {
                    // eslint-disable-next-line no-nested-ternary
                    const sortedOrganization = organizationResult.sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
                    self.companies = sortedOrganization;
                    self.$store.commit('setOrganizations', { result: sortedOrganization });

                    if (organizationResult.length === 1) {
                      const organization = organizationResult[0];
                      self.getLocations(self.$store.state.user.role, organization.uuid);
                      self.$store.commit('setOrganization', { organization });
                    } else {
                      self.showCompanies = true;
                    }
                  } else {
                    self.$root.$emit('showToast', { message: 'Impossible to find your company info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
                  }
                  elButton.classList.remove('is-loading');
                })
                .catch(() => {
                  self.$root.$emit('showToast', { message: 'Impossible to find your company info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
                  elButton.classList.remove('is-loading');
                });
            } else {
              self.getLocations(role);
            }
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to login. Check if your email and password are correct', options: { cssClass: 'is-danger', duration: 10000 } });
            elButton.classList.remove('is-loading');
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Technical issue. Please try again later', options: { cssClass: 'is-danger', duration: 10000 } });
          elButton.classList.remove('is-loading');
        });
    },
    getLocations(role, organizationUuid) {
      const elButton = this.$el.querySelector('button');
      const self = this;

      userService.getLocations(role, organizationUuid)
        .then((resp) => {
          const locationsData = resp.data;
          const { status: locationStatus, result: locationsResult } = locationsData;
          if (locationsResult.length === 0) {
            self.$root.$emit('showToast', { message: 'You are not yet assigned to any locations. Please ask your corporate manager to assign locations to you, then come back.', options: { cssClass: 'is-danger', duration: 10000 } });
            localStorage.clear();
            elButton.classList.remove('is-loading');
            return;
          } if (locationStatus === 'success') {
            self.locationList = locationsResult;
            self.$store.commit('setLocationsList', locationsData);
            // only one location in the list ? user doesn't have to choose
            if (locationsResult.length) {
              self.setEmployeeData(locationsResult[0].uuid);
            } else {
              const employeeData = {
                result: {
                  company: { uuid: 'dd88b129-eee1-42a5-a314-de938d62a059' },
                  can_view: 0,
                  can_send: 0,
                  can_manage: 0
                }
              };

              self.$store.commit('setEmployeeData', employeeData);
              self.$store.commit('setAccountReady', false);
              let pathName = Routes.LOCATION_ADD.name;

              if (self.redirectToProfile) {
                pathName = Routes.PROFILE.name;
              }
              self.$router.push({ name: pathName });
            }
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
          }
          elButton.classList.remove('is-loading');
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
          elButton.classList.remove('is-loading');
        });
    },
    setEmployeeData(uuid) {
      const self = this;
      // getting employee data (user, company, rights) and storing it
      dashboardService.getEmployeeCompany(uuid)
        .then((response) => {
          const { data } = response;

          if (data.status === 'success') {
            self.$store.commit('setEmployeeData', data);
            let pathName = Routes.DASHBOARD.name;

            if (self.redirectToProfile) {
              pathName = Routes.PROFILE.name;
            }
            workflowService.getWorkflowList(uuid)
              .then(({ data: { status, result } }) => {
                self.$store.commit('setAccountReady', (status === 'success' && result.list.length));
                self.$router.push({ name: pathName });
              })
              .catch(() => {
                self.$store.commit('setAccountReady', false);
                self.$router.push({ name: pathName });
              })
              .finally(() => {
                self.showCompanies = false;
              });
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to find your employee info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Technical issue. Please try again later', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    showPassword(event) {
      if (event) { event.preventDefault(); }
      const { type, color } = this.passwordInputConfig[this.$refs.password.type];
      this.$refs.password.type = type;
      this.$refs.eye.style.color = color;
    },
    showLoginForm() {
      return !!this.$store.state.user;
    }
  }
};
</script>

<style scoped>
.control.has-icons-left .icon,
.control.has-icons-right .icon {
    height: auto;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: inherit;
    cursor: pointer;
}
</style>
